import { HealthIssue, TrustSignalsBadgeContainer } from '@dbt-labs/metadata-shared';
import { CellContext } from '@dbt-labs/sourdough';

type ExposureTrustSignalCellProps<TData extends object> = CellContext<
  TData,
  HealthIssue[]
>;

export const ExposureTrustSignalCell = <TData extends object>({
  getValue,
}: ExposureTrustSignalCellProps<TData>) => {
  const value = getValue();
  return (
    <TrustSignalsBadgeContainer
      resourceType="exposure"
      trustSignals={{ healthIssues: value }}
      shouldRenderStateHeader={true}
    />
  );
};
